import el_zh_cn from "element-plus/dist/locale/zh-cn";
import el_en from "element-plus/dist/locale/en";
import el_vi from "element-plus/dist/locale/vi";
import el_ms from "element-plus/dist/locale/ms";
import el_ja from "element-plus/dist/locale/ja";

import lang_zh_cn from "@/locales/lang/zh-cn";
import lang_en from "@/locales/lang/en";
import lang_ja from "@/locales/lang/ja";
import lang_vi from "@/locales/lang/vi";
import lang_ms from "@/locales/lang/ms";

export const LANGUAGE_MAP: Record<
	string,
	{ el: any; local: any }
> = {
	"zh-cn": {el: el_zh_cn, local: lang_zh_cn},
	en: {el: el_en, local: lang_en},
	ja: {el: el_ja, local: lang_ja},
	vi: {el: el_vi, local: lang_vi},
	ms: {el: el_ms, local: lang_ms},
};
